export default "__VITE_ASSET__BmG2KDLk__"